export default __webpack_public_path__ + "static/vodacom-logo-2a677b0f17aab202b18fbbe3dee06d32.png";